/* main slider */

$('.main_slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrow:true,
  autoplaySpeed: 5000,
  slide:'li'
});

$('.sllider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.sllider-for',
  dots: false,
  focusOnSelect: true,
  arrows: false
});

$('.service-slide').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  arrow:false,
  dots:true,
  autoplaySpeed: 2000,
  slide:'li'
});

$('.list-exhibition').easyPaginate({
    paginateElement: 'li',
    elementsPerPage: 3,
    effect: 'default',
    firstButton:false,
    lastButton:false
});

$('.easyPaginateNav .page').click(function() {
  get_pagination();
  return false;
});

/* Mobile toggle */

$(".navbar-expand-toggle,.close-nav").on('click', function () {
  $(".app-container").toggleClass("expanded");
  return false;
});

$( ".artist-img" ).insertBefore( ".author_desc h1" );

var maxHeight = 0;
$(".pro-list--desc").each(function(){
   if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
});
$(".pro-list--desc").height(maxHeight);

/* equilizer */

function equalizer(){
    var max = -1;

    $('.upcome-list li,.artist-wrap').each(function() {

      var minHeight = $(this).innerHeight();
      max = minHeight > max ? minHeight : max;

    });  
    $(".upcome-list li,.artist-wrap").css('min-height',max) 
  }

  jQuery(document).ready(function() {
    equalizer();
  });
  
  jQuery(window).resize(function() {
    equalizer();
  });

/* ajax cart */

function ajax_addtocart(form_id){
  var ajax = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery('#' + form_id).serialize(),
    dataType: 'json',
    success: function(item){
      window.location.href = "/cart";
    },
    error: function(XMLHttpRequest, textStatus){
      $('.add_cart_product').append('<p class="ajax_error_msg">'+XMLHttpRequest.responseJSON.description+'</p>');
    }
  };
  jQuery.ajax(ajax);
}

jQuery('#addtocart_btn_id').click(function(evt){
  evt.preventDefault();
  $('.add_cart_product .ajax_error_msg').remove();
  var temp_form_id = jQuery(this).closest('form').attr('id');
  ajax_addtocart(temp_form_id);
});

/* other script */

get_pagination();
function get_pagination(){
  var $c_page = $('.list-exhibition li').length;
  $('.currentPage').text($c_page);
  
  var list = $('.total-loop').html();
  $('.total_page').html(list);
}
$('.pagi_out').insertAfter('.easyPaginateNav');
$('.services-form .site-form-wrap').insertAfter('.services-form .two-part-right');


$('.nav-submenu').slideUp();
$('.arrow-right').click(function(e) {
  
  $(this).parent().find('.nav-submenu').slideToggle();
  $(this).parent().siblings().find('.nav-submenu').slideUp();

  $(this).parent().find('.second-subnav').slideToggle();
  $(this).parent().siblings().find('.second-subnav').slideUp();
  
});

$('a.parent-menu-link').click(function(e) {
  
  $(this).parent().find('.nav-submenu').slideToggle();
  $(this).parent().siblings().find('.nav-submenu').slideUp();

  $(this).parent().find('.second-subnav').slideToggle();
  $(this).parent().siblings().find('.second-subnav').slideUp();
  
});